import { NgClass } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';
import { LocationLiveUpdateService } from '@raxapp/live-updates/location-live-updates/location-live-update.service';
import { ActiveTenantLocationStore } from '@raxapp/multi-tenants/ActiveTenantLocation.store';
import { UsersUserSideMenuService } from '@raxapp/users/user-side-menu/user-side-menu.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'rax-app-toolbar',
    templateUrl: './app-toolbar.component.html',
    styleUrls: ['./app-toolbar.component.scss'],
    imports: [MatToolbar, MatIcon, MatButtonModule, NgClass, RouterLink],
})
export class AppToolbarComponent {
    private userSideMenuService = inject(UsersUserSideMenuService);
    private activeTenantLocationStore = inject(ActiveTenantLocationStore);
    private locationLiveUpdateService = inject(LocationLiveUpdateService);

    public toolbarEnvClass = environment.envName + '-toolbar';

    public tenantIdCode = computed(() => this.activeTenantLocationStore.activeTenant()?.tenantIdCode);
    public activeLocationName = computed(() => this.activeTenantLocationStore.activeLocation()?.locationName);

    private hasActiveLocation = this.activeTenantLocationStore.hasActiveLocation;
    public showLocationNameButton = computed<boolean>(() => {
        return this.hasActiveLocation();
    });

    public showBookerButton = computed<boolean>(() => {
        return !this.hasActiveLocation();
    });

    public liveUpdateConnectedStatusColor = computed(() => (this.locationLiveUpdateService.isConnected() === true ? '#74b574' : '#ca5e59'));
    public liveUpdateConnectedStatusText = computed(() => {
        const statusText = this.locationLiveUpdateService.isConnected() === true ? 'verbonden' : 'niet verbonden';
        return 'Live Locatie Updates: ' + statusText;
    });

    public onOpenAppSideMenuButtonClick(): void {
        this.userSideMenuService.openSideMenu();
    }
}
